import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Table from './Table';
import FilterBar from './FilterBar';
import Pagination from './Pagination';
import Paper from './Paper';
import getList from '../../services/getList';

const propTypes = {
  uri: PropTypes.string.isRequired,
  params: PropTypes.shape({}).isRequired,
  headers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  filters: PropTypes.node,
  refreshRow: PropTypes.string,
  onRowRefreshed: PropTypes.func,
};

const defaultProps = {
  filters: null,
  refreshRow: null,
  onRowRefreshed: () => {},
};

function DataTable(props) {
  const {
    uri, params, headers, filters, refreshRow, onRowRefreshed,
  } = props;
  const {
    data, currentPage, totalItems, perPage, isLoading, changePage, changeParams, reload, from, refreshSingleRow,
  } = getList(uri, params);
  const tableHeaders = headers;
  const tableData = data;
  const tableActions = { reload };

  useEffect(() => {
    changeParams(params);
  }, [params]);

  useEffect(() => {
    if (refreshRow) {
      refreshSingleRow(refreshRow);
      onRowRefreshed();
    }
  }, [refreshRow]);

  return (
    <Paper>
      {filters && (
        <FilterBar>
          {filters}
        </FilterBar>
      )}

      <Table
        headers={tableHeaders}
        data={tableData || []}
        actions={tableActions}
        isLoading={isLoading}
        from={from}
      />

      <Pagination
        currentPage={currentPage}
        pagesDisplayed={5}
        resultsPerPage={perPage}
        totalResults={totalItems}
        onChangePage={changePage}
      />
    </Paper>
  );
}

DataTable.propTypes = propTypes;
DataTable.defaultProps = defaultProps;

export default DataTable;
